import axios, { AxiosRequestConfig } from "axios";

export interface ISpecialContent
{
	Element: string;
	Html: string;
	ReplaceExisting: boolean;
}
interface IContentDto
{
	__type: string;
	ABContent: Array<ISpecialContent>;
	AccountName: string;
	BasketID: number;
	CartID: number;
	CartItemCount: number;
	CloseBannerText: string;
	CouponBanner: string;
	CouponID: number;
	CouponIsPromotion: boolean;
	CouponIsValid: boolean;
	DisplayDataPrivacyPolicyLink: boolean;
	DisplayDataPrivacyPolicyModal: boolean;
	DisplaySellDataOptOutLink: boolean;
	DomainProjectID: string;
	ExperimentID: string;
	HasPreOrderCart: boolean;
	HeaderCart: string;
	InternationalBanner: string;
	IsDirectToCheckout: boolean;
	IsMobileDevice: boolean;
	IsTabletDevice: boolean;
	PreOrderID: number;
	PreOrderItemCount: number;
	PreOrderItemQuantity: number;
	PreOrderSubTotal: number;
	RentalEventDate: string;
	RentalEventDays: number;
	ScheduledContent: Array<ISpecialContent>;
	SecureDomainUrl: string;
	SmsModalEligible: boolean;
	SmsWelcomeCoupon: string;
	SubTotal: number;
	TotalItemQuantity: number;
	TransitTimeContent: Array<ISpecialContent>;
	WebsiteName: string;
	WebsiteSuggestionBanner: string;
	WelcomeCoupon: string;
}

export interface IContentCallback
{
	(): void;
}

export class ContentService
{
	static Response: IContentDto;

	public ApiCall = (): Promise<any> =>
	{
		const apiUrl = "/services/client.asmx/GetContent";
		const data = {
			url: document.URL,
			referrer: document.URL
		};

		return axios.post(apiUrl, data)
			.then((response) =>
			{
				ContentService.Response = response.data.d;
			})
			.catch((error) =>
			{
				if (error.code !== "ECONNABORTED")
				{
					console.log(error);
				}
			});
	};
}